export default "__VITE_ASSET__567b449f__"